"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_1 = __importStar(require("react"));
const noop_1 = __importDefault(require("lodash-es/noop"));
const useRefsCompose_1 = __importDefault(require("../../../../utils/hooks/useRefsCompose"));
const useSyncState_1 = __importStar(require("../../../../utils/hooks/useSyncState"));
// eslint-disable-next-line import/no-cycle
const InputText_1 = __importDefault(require("../InputText"));
const getInputMaskState_1 = __importDefault(require("./utils/getInputMaskState"));
const constants_1 = __importDefault(require("./constants"));
const hasRef = (ref) => Boolean(ref && ref.current);
const InputMask = react_1.default.forwardRef(({ value: propsValue, mask: propMask = '', onChange = noop_1.default, onBlur = noop_1.default, onInvalid = noop_1.default, onValid = noop_1.default, ...props }, ref) => {
    const innerRef = (0, react_1.useRef)(null);
    const completeRef = (0, react_1.useRef)(false);
    const stringPropsValue = String(propsValue);
    const { mask, definitions } = constants_1.default[propMask] || { mask: propMask };
    const [viewState, setViewState] = (0, useSyncState_1.default)(() => (0, getInputMaskState_1.default)({
        mask,
        definitions,
        input: stringPropsValue,
    }), (0, react_1.useCallback)(({ value, viewValue, complete, event }) => {
        if (value !== stringPropsValue) {
            onChange(value, event);
        }
        if (completeRef.current !== complete) {
            completeRef.current = complete;
            if (complete) {
                onValid(value);
            }
            else {
                onInvalid(value);
            }
        }
        if (hasRef(innerRef)) {
            innerRef.current.value = viewValue;
        }
    }, [onChange, stringPropsValue]), useSyncState_1.shallowEqualityCheck);
    (0, react_1.useEffect)(() => {
        setViewState((0, getInputMaskState_1.default)({
            mask,
            definitions,
            input: stringPropsValue,
            typeahead: true, // add all mask symbols if change comes with props
        }), true);
    }, [mask, definitions, setViewState, stringPropsValue]);
    const handleChange = (0, react_1.useCallback)((value, event) => {
        setViewState((0, getInputMaskState_1.default)({
            mask,
            definitions,
            input: value,
            typeahead: event.inputType === 'insertText',
            event,
        }), true);
    }, [mask, definitions, setViewState]);
    const handleBlur = (0, react_1.useCallback)((event) => {
        setViewState((0, getInputMaskState_1.default)({
            mask,
            definitions,
            input: viewState.viewValue,
        }));
        onBlur(event);
    }, [mask, definitions, onBlur, viewState.viewValue]);
    return ((0, jsx_runtime_1.jsx)(InputText_1.default, { ...props, autoComplete: "off", value: viewState.viewValue, onChange: handleChange, onBlur: handleBlur, ref: (0, useRefsCompose_1.default)(ref, innerRef), uncontrolled: true }));
});
exports.default = InputMask;
